module.exports = __webpack_public_path__ + "img/scope3category2.724a7b4c.svg";